export default {
  theme: {
    blue: '블루',
    teal: '틸',
    rose: '로즈',
    violet: '바이올렛',
    orange: '오렌지',
  },
  home: {
    started: "시작하기",
    components: "컴포넌트",
    tableOfContent: "목차",
    version: "버전",
    changelog: "변경 로그",
    download: "다운로드",
  },
  toolbar: {
    plus: '추가',
    account: '계정',
    logout: '로그아웃',
    setting: '설정',
    theme: '테마',
    language: '언어',
  },
  task: {
    task: '작업',
    listView: '목록 보기',
    cardView: '카드 보기',
  },
  project: {
    listView: '목록 보기',
    cardView: '카드 보기',
  },
  document: {
    listView: '목록 보기',
    cardView: '카드 보기',
  },
  common: {
    save: '저장',
    cancel: '취소',
    confirm: '확인',
    delete: '삭제',
    edit: '편집',
    more: '더보기',
    message: '메시지',
    notice: '알림',
    contact: '연락',
    userLogin: '사용자 로그인',
    userLogout: '사용자 로그아웃',
    previous: '이전',
    next: '다음',
    goToSlide: '슬라이드 {index}로 이동',
    confirmDelete: '이 작업을 삭제하시겠습니까?',
    carouselImage: '캐러셀 이미지 {index}',
    collapseCode: '코드 접기',
    expandCode: '코드 펼치기',
    copyCode: '코드 복사',
    totalTasks: '총 작업',
    hide: '숨기기',
    show: '보기',
    completed: '완료',
    total: '총계',
    quantity: '수량',
    pleaseSelect: '선택해주세요',
    pleaseInput: '입력해주세요',
    selectUser: '사용자 선택',
    back: '뒤로',
  },
  date: {
    sunday: '일요일',
    monday: '월요일',
    tuesday: '화요일',
    wednesday: '수요일',
    thursday: '목요일',
    friday: '금요일',
    saturday: '토요일',
    january: '1월',
    february: '2월',
    march: '3월',
    april: '4월',
    may: '5월',
    june: '6월',
    july: '7월',
    august: '8월',
    september: '9월',
    october: '10월',
    november: '11월',
    december: '12월',
    today: '오늘',
    clear: '지우기',
    now: '지금',
  },
};

